import { makeAutoObservable, runInAction } from 'mobx'

import { chooseDocumentLetterTemplate, chooseLetterTemplates } from '../Helpers/letterTemplateChoice'
import { LoadLetterTemplatesTask } from '../Tasks/LoadLetterTemplatesTask'

import type { LetterTemplateOption } from '../Contracts/ILetter'
import type { LetterProviderValue } from '@/Ship/Contracts/LetterProvider'

/**
 * Шаблони кнопки «Відправити лист» одного власника (`SPEC-013` §6.2, §9.3):
 * шаблон за замовчуванням і решта для меню «Генерація документу». Поки
 * вантажаться — кнопка крутиться; збій — кнопки немає (`failed`), але й
 * пояснення «немає шаблону за замовчуванням» теж: воно було б неправдою.
 */
export class LetterTemplatesStore {
    templates: LetterTemplateOption[] = []
    isLoaded = false
    failed = false

    constructor(
        private readonly provider: LetterProviderValue,
        private readonly ownerUuid: string | null
    ) {
        makeAutoObservable<LetterTemplatesStore, 'provider' | 'ownerUuid'>(
            this,
            { provider: false, ownerUuid: false },
            { autoBind: true }
        )
    }

    get defaultTemplate(): LetterTemplateOption | null {
        return chooseLetterTemplates(this.templates, this.ownerUuid).defaultTemplate
    }

    get otherTemplates(): LetterTemplateOption[] {
        return chooseLetterTemplates(this.templates, this.ownerUuid).others
    }

    /** Лист документа — перший шаблон провайдера, `isDefault` не враховується. */
    get documentTemplate(): LetterTemplateOption | null {
        return chooseDocumentLetterTemplate(this.templates)
    }

    async load(): Promise<void> {
        try {
            const templates = await LoadLetterTemplatesTask(this.provider, this.ownerUuid)

            runInAction(() => {
                this.templates = templates
                this.failed = false
            })
        } catch {
            runInAction(() => {
                this.templates = []
                this.failed = true
            })
        } finally {
            runInAction(() => {
                this.isLoaded = true
            })
        }
    }
}
